export const REDIRECT_URL_KEY = 'redirect_url';
const ONE_MINUTE = 60000;

interface IRedirectState {
  expiresOn: number;
  url: string;
}

export interface IStorage {
  getItem(key: string): string | null;
  removeItem(key: string): void;
  setItem(key: string, value: string): void;
}

export default class RedirectStorage {
  constructor(private readonly storage: IStorage = window.localStorage) {}

  public get = (): string | null => {
    const redirectString = this.storage.getItem(REDIRECT_URL_KEY);

    if (redirectString === null) {
      return null;
    }
    this.storage.removeItem(REDIRECT_URL_KEY);
    try {
      const redirect: IRedirectState = JSON.parse(redirectString);
      if (redirect.url && redirect.expiresOn > Date.now()) {
        return redirect.url;
      }

      return null;
    } catch (e) {
      return null;
    }
  };

  public set = (url: string): void => {
    const serialisedUrl = JSON.stringify({
      expiresOn: Date.now() + ONE_MINUTE,
      url,
    });
    this.storage.setItem(REDIRECT_URL_KEY, serialisedUrl);
  };
}
